import Markdown, { MarkdownToJSX } from 'markdown-to-jsx';
import { Typography } from '@mui/material';

import { useMarkdownWrapperStyles } from './useMarkdownWrapperStyles';

export interface MarkdownWrapperProps {
  children: string;
  options?: MarkdownToJSX.Options;
}

export const MarkdownWrapper = ({
  children,
  options,
  ...rest
}: MarkdownWrapperProps) => {
  const { classes } = useMarkdownWrapperStyles();

  return (
    <Markdown
      {...rest}
      options={{
        ...options,
        overrides: {
          ...options?.overrides,
          ol: {
            component: Typography,
            props: {
              className: classes.ol,
              component: 'ol',
              variant: 'body2',
            },
          },
          p: {
            component: 'p',
            props: {
              className: classes.p,
            },
          },
          ul: {
            component: Typography,
            props: {
              className: classes.ul,
              component: 'ul',
              variant: 'body2',
            },
          },
        },
      }}
    >
      {children}
    </Markdown>
  );
};
